module.exports = __webpack_public_path__ + "assets/images/scene-2_69bfed39643f84ec5bb00722296196d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/croma-abeldo-dialogs/scene-2.png
// module id = 220
// module chunks = 0